module.exports = __webpack_public_path__ + "img/logo-awaken.2c6987bf.webp";